import { render, staticRenderFns } from "./Bctime.vue?vue&type=template&id=5ccfd816&scoped=true"
import script from "./Bctime.vue?vue&type=script&lang=js"
export * from "./Bctime.vue?vue&type=script&lang=js"
import style0 from "./Bctime.vue?vue&type=style&index=0&id=5ccfd816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfd816",
  null
  
)

export default component.exports